import React from "react";
import SmartIcon from "../SmartIcon.tsx";
import {GiTv} from "react-icons/gi";
import iso6391 from "iso-639-1";
import Dot from "../Dot.tsx";
import {Series} from "../../models/interfaces/series.interface.ts";

interface SeriesModalOverviewProps {
  series: Series
}

const SeriesModalOverview: React.FC<SeriesModalOverviewProps> = ({series}: SeriesModalOverviewProps) => {
  return (
    <div className="flex items-center gap-4">
      <SmartIcon name={GiTv} className="h-14 w-14 mb-2 fill-brandPurple-500"/>
      <div className="flex flex-col justify-center">
        <span className="text-2xl font-bold">{series.name}</span>
        <div className="flex items-center gap-3">
              <span className="text-sm text-n-300">
                Source: {iso6391.getName(series.info.sourceLanguage)}
              </span>
          <Dot className="mt-0.5"/>
          <span className="text-sm text-n-300">
                Characters: {series.info.characters.length}
              </span>
          <Dot className="mt-0.5"/>
          <span className="text-sm text-n-300">
                Genres: {series.info.genres.length}
              </span>
          <Dot className="mt-0.5"/>
          <span className="text-sm text-n-300">
                Localization Terms: {series.info.terms.length}
              </span>
        </div>
      </div>
    </div>
  )
}

export default SeriesModalOverview;